import type { FeatureMapping, SelectedTab } from '../../types/data-catalog.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business データカタログの機能別タブ。「全体」＋各機能キーのタブを横並び（スマホは横スクロール）で表示する。
 * @graph-connects none
 */
export function FeatureTabs({
  featureMapping,
  selectedTab,
  onTabChange,
}: {
  featureMapping: FeatureMapping[];
  selectedTab: SelectedTab;
  onTabChange: (tab: SelectedTab) => void;
}) {
  const tabs: { key: SelectedTab; label: string }[] = [
    { key: 'all', label: '全体' },
    ...featureMapping
      .filter((fm) => fm.featureKey !== 'mart-views' && fm.featureKey !== 'raw')
      .map((fm) => ({ key: fm.featureKey, label: fm.label })),
  ];

  return (
    <div className="flex gap-1 overflow-x-auto pb-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => {
            onTabChange(tab.key);
          }}
          className={`whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${
            selectedTab === tab.key
              ? 'bg-[var(--color-accent-primary)] text-white'
              : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-bg-base)]'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
